import { render } from "./ChatInfoBanner.vue?vue&type=template&id=68554e42"
import script from "./ChatInfoBanner.vue?vue&type=script&lang=js"
export * from "./ChatInfoBanner.vue?vue&type=script&lang=js"
script.render = render

export default script